import { reactive } from 'vue'
const { v4: uuidv4 } = require('uuid');
const CryptoJS = require("crypto-js");
const hmacSHA256 = require("crypto-js/hmac-sha256");
const Base64 = require("crypto-js/enc-base64");
import { useToast } from "vue-toast-notification";
import 'vue-toast-notification/dist/theme-bootstrap.css';
const { fetch: originalFetch } = window;
const env = process.env.NODE_ENV;

function showTips(message) {
  useToast().open({
    message: message,
    type: 'default',
  });
}
async function postData(apiUrl, data, para = {}) {
  var paraInit = { token: false, sign: false };
  para = { ...paraInit, ...para };
  let timestamp = new Date().getTime();

  if (para.token) {
    if (this.userinfo.token == "") {
      console.log("no token sign in 1.");
      return;
    }
  }

  let sign = '';
  if (para.sign) {
    if (this.userinfo.token == "") {
      console.log("no token,sign in 2.");
      return;
    }
    sign = _sign(this.userinfo.token, timestamp, data);
  }

  const headers = {
    'x-isRelease': 'true',
    'x-platform': 'web',
    'x-version': this.version,
    'x-locale': window.navigator.language || window.navigator.browserLanguage,
    'x-timestamp': timestamp,
    'x-deviceId': getDeviceId(),
    'x-token': para.token ? this.userinfo.token : "",
    'x-sign': sign,
  };
  try {
    window.fetch = async (...args) => {
      let [resource, config] = args;
      let response = await originalFetch(resource, config);
      if (!response.ok) {
        // 401 error handling
        return Promise.reject(response);
      }
      return response;
    };

    const response = await fetch(this.baseApiUrl + apiUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        path: apiUrl,
        body: data
      }),
    }).catch((error) => {
      console.error(error.status);
      if (error.status == 401) {
        this.userinfo = {
          email: "",
          token: "",
        };
        localStorage.removeItem("userinfo");
        // this.$router.push('/signin')
        location.href = '/#signin';
      }
    });
    return await response.json();
  } catch {
    return {
      code: 500,
      msg: '',
      body: {}
    };
  }
}
function _sign(token, timestamp, data) {
  let httpData = '';
  let dataTP = {};
  if (data) {
    for (const k in data) {
      if (Object.hasOwnProperty.call(data, k)) {
        let v = data[k];
        if (v instanceof Array || v instanceof Object) {
          v = JSON.stringify(v);
        } else {
          v = v.toString();
        }
        if (v !== '' && k.substring(0, 1) !== '_') {
          dataTP[k] = v;
        }
      }
    }
    if (dataTP) {
      const sortedKeys = Object.keys(dataTP).sort();
      for (let f of sortedKeys) {
        httpData = `${httpData}${f}=${dataTP[f]}&`;
      }
      httpData = httpData.substring(0, httpData.length - 1);
    }
  }
  httpData = `${httpData}￥￥token=${token}￥￥timestamp=${timestamp}`;
  const hmacDigest = Base64.stringify(hmacSHA256(httpData, decode()));
  return hmacDigest;

}
function decode() {
  var cc = [99, 21, 'd1', 'df', 0x05, 0xff, 'b9', 71, 117, '1&x', 'xc4', 0x08, 134, '#$'];
  var bytes = CryptoJS.AES.decrypt(env == "development" ?
    "U2FsdGVkX1/ALWE8Z36sbymPhsvETbCUxzOWR5DhYnmuGY9+oCpYMMniRq/Ko/C+KL9+Tudo0ad61rHkMqclVQ==" :
    "U2FsdGVkX1+Pmji9NCk+0N4H+X/YfqhrW/hYhY/67GL4puAB7CGYr4fbS8iqnEWET8FQUtDO2kVCtnagoYv4hQ==",
    cc.toString());
  return bytes.toString(CryptoJS.enc.Utf8);
}
function getDeviceId() {
  let xsudeviceId = localStorage.getItem("xsudeviceId");
  if (!xsudeviceId) {
    xsudeviceId = uuidv4();
    localStorage.setItem("xsudeviceId", xsudeviceId);
  }
  return xsudeviceId;
}
function sysncUserInfo() {
  let userinfo = localStorage.getItem("userinfo");
  if (userinfo) {
    this.userinfo = JSON.parse(userinfo);
  }
}
function unixToTime(val) {
  if (val == 0) {
    return ""
  }
  return new Date(val).toLocaleString('zh-CN', {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",  // 添加小时选项  
    minute: "2-digit",  // 添加分钟选项  
    second: "2-digit"  // 添加秒选项  
  });
}
function unixToGoodTime(timestamp) {
  if (timestamp == 0) {
    return ""
  }
  // Create a new Date object and set it to the current time
  var now = new Date();

  // Create a new Date object and set it to the given timestamp
  var then = new Date(timestamp);

  // Calculate the time difference between two dates in milliseconds
  var diff = now.getTime() - then.getTime();

  // Format the time based on the time difference
  if (diff < 60000) { // within 1 minute
    return 'Just now';
  } else if (diff < 3600000) { //1 hour
    return Math.floor(diff / 60000) + ' minutes ago';
  } else if (diff < 86400000) { //1 day
    return Math.floor(diff / 3600000) + ' hours ago';
  } else {
    return Math.floor(diff / 86400000) + ' days ago';
  }
}

export const global = reactive({
  version: '1.0.0',
  baseApiUrl: env == "development" ? "http://127.0.0.1:8083/" : "https://api.iot.sumsg.com/",//
  pageSize: 8,
  userinfo: { email: "", token: "", avatar: "", nickname: "", telphone: "" },
  postData,
  sysncUserInfo,
  showTips,
  unixToTime,
  unixToGoodTime
})